export const languageMap = {
  en: 1,
  hi: 2,
  kn: 3,
  ml: 4,
  ta: 5,
  te: 6,
  mr: 7,
  gu: 8,
  bn: 9,
  or: 10,
  pa: 11,
};

export const languageStateCode = [
  { State: 'Andaman and Nicobar Islands', Code: 'AN', Language: 'hi', LanguageName: 'Hindi' },
  { State: 'Andhra Pradesh', Code: 'AP', Language: 'te', LanguageName: 'Telugu' },
  { State: 'Andhra Pradesh (New)', Code: 'AD', Language: 'te', LanguageName: 'Telugu' },
  { State: 'Arunachal Pradesh', Code: 'AR', Language: 'hi', LanguageName: 'Hindi' },
  { State: 'Assam', Code: 'AS', Language: 'hi', LanguageName: 'Hindi' },
  { State: 'Bihar', Code: 'BH', Language: 'hi', LanguageName: 'Hindi' },
  { State: 'Chandigarh', Code: 'CH', Language: 'hi', LanguageName: 'Hindi' },
  { State: 'Chattisgarh', Code: 'CT', Language: 'hi', LanguageName: 'Hindi' },
  { State: 'Dadra and Nagar Haveli', Code: 'DN', Language: 'gu', LanguageName: 'Gujarati' },
  { State: 'Daman and Diu', Code: 'DD', Language: 'gu', LanguageName: 'Gujarati' },
  { State: 'Delhi', Code: 'DL', Language: 'hi', LanguageName: 'Hindi' },
  { State: 'Goa', Code: 'GA', Language: 'kn', LanguageName: 'Kannada' },
  { State: 'Gujarat', Code: 'GJ', Language: 'gu', LanguageName: 'Gujarati' },
  { State: 'Haryana', Code: 'HR', Language: 'hi', LanguageName: 'Hindi' },
  { State: 'Himachal Pradesh', Code: 'HP', Language: 'hi', LanguageName: 'Hindi' },
  { State: 'Jammu and Kashmir', Code: 'JK', Language: 'hi', LanguageName: 'Hindi' },
  { State: 'Jharkhand', Code: 'JH', Language: 'hi', LanguageName: 'Hindi' },
  { State: 'Karnataka', Code: 'KA', Language: 'kn', LanguageName: 'Kannada' },
  { State: 'Kerala', Code: 'KL', Language: 'ml', LanguageName: 'Malayalam' },
  { State: 'Lakshadweep Islands', Code: 'LD', Language: 'ml', LanguageName: 'Malayalam' },
  { State: 'Madhya Pradesh', Code: 'MP', Language: 'hi', LanguageName: 'Hindi' },
  { State: 'Maharashtra', Code: 'MH', Language: 'mr', LanguageName: 'Marathi' },
  { State: 'Manipur', Code: 'MN', Language: 'hi', LanguageName: 'Hindi' },
  { State: 'Meghalaya', Code: 'ME', Language: 'hi', LanguageName: 'Hindi' },
  { State: 'Mizoram', Code: 'MI', Language: 'hi', LanguageName: 'Hindi' },
  { State: 'Nagaland', Code: 'NL', Language: 'hi', LanguageName: 'Hindi' },
  { State: 'Odisha', Code: 'OR', Language: 'or', LanguageName: 'Odia' },
  { State: 'Pondicherry', Code: 'PY', Language: 'ta', LanguageName: 'Tamil' },
  { State: 'Punjab', Code: 'PB', Language: 'pa', LanguageName: 'Punjabi' },
  { State: 'Rajasthan', Code: 'RJ', Language: 'hi', LanguageName: 'Hindi' },
  { State: 'Sikkim', Code: 'SK', Language: 'hi', LanguageName: 'Hindi' },
  { State: 'Tamil Nadu', Code: 'TN', Language: 'ta', LanguageName: 'Tamil' },
  { State: 'Telangana', Code: 'TS', Language: 'te', LanguageName: 'Telugu' },
  { State: 'Tripura', Code: 'TR', Language: 'bn', LanguageName: 'Bengali' },
  { State: 'Uttar Pradesh', Code: 'UP', Language: 'hi', LanguageName: 'Hindi' },
  { State: 'Uttarakhand', Code: 'UT', Language: 'hi', LanguageName: 'Hindi' },
  { State: 'West Bengal', Code: 'WB', Language: 'bn', LanguageName: 'Bengali' },
];
